<template>
  <div class="agreement" :class="{ wide: isWideScreen }">
    <div class="ag-header">
      <div class="brand">笔记相册</div>
      <h1 class="ag-title">用户协议</h1>
      <div class="ag-meta">
        <span>生效日期：2026年8月25日</span>
      </div>
    </div>

    <div class="ag-body">
      <section class="sec">
        <h2>一、总则</h2>
        <p>欢迎使用"笔记相册"（以下简称"本应用"）。在使用本应用前，请您仔细阅读并充分理解本协议的全部内容。</p>
        <p>本协议是您与本应用开发方之间就本应用的使用所订立的协议。一旦您下载、访问或使用本应用，即视为您已阅读、理解并同意接受本协议的全部条款。若您不同意本协议的任何内容，请勿使用本应用。</p>
      </section>

      <section class="sec">
        <h2>二、服务与数据说明</h2>
        <p>本应用是一款在您设备本地运行的相册类工具。关于功能与数据处理，请您特别留意以下说明：</p>
        <ol class="circle">
          <li>本应用会读取您设备本地的相册（照片与视频），用于浏览、整理、分类、清理与美化等本地功能；只有在您授权后，本应用才会访问相册。</li>
          <li>本应用<strong>不会收集、上传、传输或向任何第三方发送</strong>您的照片、视频及任何个人信息。您的所有数据均仅保存在您自己的设备本地，不经过我们的服务器，我们也无法获取您的数据。</li>
          <li>本应用<strong>可完全离线使用</strong>。在无网络连接（如开启飞行模式）的环境下，除需要联网才能完成的功能（如应用内购买）外，核心相册功能均可正常运行。</li>
          <li>本应用<strong>不会在后台静默上传任何数据</strong>，也不会在您不知情的情况下将任何信息发送出去。</li>
        </ol>
        <div class="ag-highlight">简单说：本应用读取您设备上的相册做整理与清理，但不会把您的任何照片或个人信息收集或上传到任何地方，断网也能用。</div>
      </section>

      <section class="sec">
        <h2>三、内购与付费说明</h2>
        <ol class="num">
          <li>本应用提供内购项目，均为<strong>一次性购买</strong>。您通过应用内购买（IAP）完成支付后，相应功能<strong>永久解锁</strong>，购买后长期有效。</li>
          <li>本应用内购为一次性付费、永久有效，<strong>不设订阅、不自动续费、不按期扣款</strong>，您无需担心被反复扣费。</li>
          <li>内购价格以购买页面显示为准。本应用可能不定期推出优惠活动，活动价格以活动页面为准。</li>
          <li>若您更换设备或重装本应用，可通过您所用应用商店提供的"恢复购买"功能重新获取已购权益。</li>
        </ol>
      </section>

      <section class="sec">
        <h2>四、知识产权</h2>
        <ol class="num">
          <li>本应用及其相关服务中所包含的文本、图片、界面、算法、软件代码等内容的知识产权均归本应用开发方或相关权利人所有，受法律法规保护。</li>
          <li>您在使用本应用过程中生成或导入的内容（如您的照片与视频），其知识产权及由此产生的相关权利归您本人所有。</li>
          <li>未经书面许可，任何人不得擅自复制、修改、传播、出售本应用或其组成部分。</li>
        </ol>
      </section>

      <section class="sec">
        <h2>五、用户内容与使用规范</h2>
        <ol class="num">
          <li>您在使用本应用时应遵守中华人民共和国相关法律法规，不得利用本应用制作、存储或传播任何违法或不良信息。</li>
          <li>您承诺不利用本应用从事任何侵犯他人合法权益（包括但不限于肖像权、隐私权、著作权）的行为。</li>
          <li>如您违反上述约定，本应用有权限制相关功能，由此产生的后果由您自行承担。</li>
        </ol>
      </section>

      <section class="sec">
        <h2>六、隐私保护</h2>
        <p>我们高度重视您的隐私。关于我们如何处理您的信息，请参阅本应用《用户隐私政策》。正如本协议第二条所述，本应用不收集、不上传您的任何个人数据与照片信息，您可放心使用。</p>
      </section>

      <section class="sec">
        <h2>七、免责声明</h2>
        <ol class="num">
          <li>本应用将尽合理努力保障服务的稳定运行，但不保证服务完全不间断、无错误。</li>
          <li>因不可抗力（包括但不限于自然灾害、政策变化、网络攻击等）导致服务中断，本应用不承担责任。</li>
          <li>本应用有权因系统维护、升级等原因暂停部分或全部服务，将提前在应用内公告。</li>
        </ol>
      </section>

      <section class="sec">
        <h2>八、协议变更</h2>
        <ol class="num">
          <li>本应用有权根据法律法规变化或业务需要修改本协议内容。</li>
          <li>修改后的协议将在应用内公示，若您在协议修改后继续使用本应用，视为同意修改后的协议。</li>
          <li>如您不同意修改后的协议，可停止使用本应用并卸载。</li>
        </ol>
      </section>

      <section class="sec">
        <h2>九、其他</h2>
        <ol class="num">
          <li>本协议的订立、执行和解释均适用中华人民共和国法律。</li>
          <li>本协议未尽事宜，按照相关法律法规执行。</li>
          <li>如您对本协议有任何疑问，请通过电子邮件 <a class="ag-mail" href="mailto:support@capturedslr.cc">support@capturedslr.cc</a> 与我们联系。</li>
        </ol>
      </section>

    </div>
  </div>
</template>

<script>
export default {
  name: "qimiaoUserAgreement",
  props: {
    isWideScreen: Boolean,
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.agreement {
  background: #fff;
  text-align: left;
  color: #1f2933;
  font-family: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",
    "Helvetica Neue", Arial, sans-serif;
  line-height: 1.85;
  font-size: 16px;
  margin: 0 auto;
  max-width: 860px;
  padding: 24px 16px 48px;
}
.agreement.wide {
  padding: 36px 28px 56px;
  margin-top: 20px;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}
.ag-header {
  background: linear-gradient(135deg, #fdba74, #fb923c);
  color: #fff;
  text-align: center;
  padding: 32px 16px 26px;
  border-radius: 10px 10px 0 0;
  margin: -24px -16px 0;
}
.agreement.wide .ag-header {
  margin: -36px -28px 0;
}
.ag-header .brand {
  font-size: 0.95rem;
  letter-spacing: 0.18em;
  opacity: 0.92;
  margin-bottom: 8px;
}
.ag-title {
  font-size: 1.7rem;
  font-weight: 700;
  margin: 0;
  letter-spacing: 0.04em;
}
.ag-meta {
  margin-top: 12px;
  font-size: 0.9rem;
  opacity: 0.9;
}
.ag-meta .dot {
  margin: 0 10px;
  opacity: 0.6;
}
.sec {
  margin-top: 28px;
}
.sec h2 {
  font-size: 1.12rem;
  color: #fb923c;
  margin: 0 0 12px;
  padding-left: 0.6em;
  border-left: 4px solid #fb923c;
  line-height: 1.5;
}
.sec p {
  margin: 0.6em 0;
}
ol.num {
  list-style: decimal;
  padding-left: 1.6em;
  margin: 0.6em 0;
}
ol.num > li {
  margin: 0.45em 0;
  padding-left: 0.2em;
}
ol.circle {
  list-style: none;
  counter-reset: c;
  padding-left: 1.7em;
  margin: 0.6em 0;
}
ol.circle > li {
  counter-increment: c;
  position: relative;
  margin: 0.45em 0;
}
ol.circle > li::before {
  content: "（" counter(c) "）";
  position: absolute;
  left: -1.7em;
  color: #fb923c;
  font-weight: 600;
}
.ag-highlight {
  margin-top: 14px;
  padding: 14px 16px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-left: 4px solid #fb923c;
  border-radius: 8px;
  color: #7c3a0e;
  font-size: 0.94rem;
  line-height: 1.7;
}
.ag-note {
  margin-top: 26px;
  padding: 14px 16px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 8px;
  color: #6b7280;
  font-size: 0.88rem;
}
.ag-contact {
  margin-top: 18px;
  padding: 14px 16px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 8px;
  color: #7c3a0e;
  font-size: 0.95rem;
  text-align: center;
}
.ag-mail {
  color: #ea580c;
  text-decoration: none;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/views/agreements/qimiao-xiangce/user-agreement.vue